module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch3"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch3.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-3"
    }
  }, [_vm._v("Dangerous experiment? What does that mean? you wonder. You notice that the door is slightly open. Oh, no! Denny must have run in here, you think.")])]), _c('a', {
    attrs: {
      "id": "pg-3"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You push the door open wider and peek in. There’s no sign of Denny. A tall, skinny man with long white hair tied in a ponytail is bent over a computer. The computer is hooked up to a big, strange-looking clock. Between the computer and the clock is a large square contraption that looks like a picture frame. You can hear the computer and the clock beeping and pinging.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s about time you got here!” the tall man says, straightening up. “I’m Dr. Peebles. You must be the volunteer.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Actually,” you start to say, “I’m looking for —”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s no time to waste!” Dr. Peebles interrupts. “I’m ready to start the experiment. Come on over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, I —”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here!” he says. He places a chain around your neck. On the end of the chain is something that looks like a stopwatch. A very, very odd stopwatch, with a complicated-looking dial and four big knobs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you ready?” Dr. Peebles asks.")])]), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-3"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Turn to ")])]), _c('a', {
    attrs: {
      "href": "#/e9780545841016_ch004"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 4")])]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3456088","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841016_ch003.vue
// module id = 72
// module chunks = 0